import { render, staticRenderFns } from "./ENDefinitionOfRanks.vue?vue&type=template&id=bf47c2e0&scoped=true&"
import script from "./ENDefinitionOfRanks.vue?vue&type=script&lang=js&"
export * from "./ENDefinitionOfRanks.vue?vue&type=script&lang=js&"
import style0 from "./ENDefinitionOfRanks.vue?vue&type=style&index=0&id=bf47c2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf47c2e0",
  null
  
)

export default component.exports